import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  verificationLoading: false,
  verificationSuccess: false,
  verificationFailed: false,
  verificationData: null,

  purchaseLoading: false,
  subscriptionSuccess: false,
  subscriptionFailed: false,

  verifyPromoCodeSuccess: false,
  verifyPromoCodeFailed: false,
  verifypromoCodeLoading: false,
  promoCodeData: null,
};

export const subscriptionSlice = createSlice({
  name: "subscriptionSlice",
  initialState,
  reducers: {
    verifyTokenLoad: (state) => {
      state.verificationLoading = true;
      state.verificationFailed = false;
    },
    verifyTokenSuccess: (state, action) => {
      state.verificationLoading = false;
      state.verificationData = action.payload;
    },
    verifyTokenFailed: (state) => {
      state.verificationLoading = false;
      state.verificationFailed = true;
    },

    userSubscriptionPurchaseLoad: (state) => {
      state.purchaseLoading = true;
    },
    userSubscriptionPurchaseSuccess: (state, action) => {
      state.purchaseLoading = false;
      state.subscriptionSuccess = true;
    },
    userSubscriptionPurchaseFailed: (state) => {
      state.purchaseLoading = false;
      state.subscriptionFailed = false;
    },

    verifyPromoCodeLoad: (state) => {
      state.verifypromoCodeLoading = true;
    },
    verifyPromoCodeSuccess: (state, action) => {
      state.verifypromoCodeLoading = false;
      state.verifyPromoCodeSuccess = true;
      state.promoCodeData = action.payload;
    },
    verifyPromoCodeFailed: (state) => {
      state.verifypromoCodeLoading = false;
      state.verifyPromoCodeFailed = false;
    },

    resetStateForPromoCode: (state) => {
      state.promoCodeData = null;
    },

    bookSlotLoad: (state) => {
      state.purchaseLoading = true;
    },
    bookSlotSuccess: (state, action) => {
      state.purchaseLoading = false;
      state.subscriptionSuccess = true;
    },
    bookSlotFail: (state) => {
      state.purchaseLoading = false;
      state.subscriptionFailed = false;
    },

    cancelSlotLoad: (state) => {
      state.purchaseLoading = true;
    },
    cancelSlotSuccess: (state, action) => {
      state.purchaseLoading = false;
      state.subscriptionSuccess = true;
    },
    cancelSlotFail: (state) => {
      state.purchaseLoading = false;
      state.subscriptionFailed = false;
    },

    rescheduleSlotLoad: (state) => {
      state.purchaseLoading = true;
    },
    rescheduleSlotSuccess: (state, action) => {
      state.purchaseLoading = false;
      state.subscriptionSuccess = true;
    },
    rescheduleSlotFail: (state) => {
      state.purchaseLoading = false;
      state.subscriptionFailed = false;
    },

    // toolsTopUsageLoad: state => {
    //     state.loading = true;
    // },

    // toolsTopUsageSuccess: (state, action) => {
    //     state.loading = false;
    //     state.topUsageData = action.payload.data
    // },

    // toolsTopUsageFail: state => {
    //     state.loading = true;
    // },
  },
});

export const {
  verifyTokenLoad,
  verifyTokenSuccess,
  verifyTokenFailed,

  userSubscriptionPurchaseLoad,
  userSubscriptionPurchaseSuccess,
  userSubscriptionPurchaseFailed,

  verifyPromoCodeLoad,
  verifyPromoCodeSuccess,
  verifyPromoCodeFailed,

  bookSlotLoad,
  bookSlotSuccess,
  bookSlotFail,

  cancelSlotLoad,
  cancelSlotSuccess,
  cancelSlotFail,

  rescheduleSlotLoad,
  rescheduleSlotSuccess,
  rescheduleSlotFail,

  resetStateForPromoCode,
} = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
